import { LdButton } from "@emdgroup-liquid/liquid/dist/react";
import styled from "@emotion/styled";
export const ButtonStyleOffTargetDownload = styled(LdButton)`
  ::part(button) {
    padding: 0.3rem 0.8rem;
    font-size: 0.8rem;
  }
`;
